import { OdooCompany, OrderingRequirementUnit, OrderMode } from 'data/__generated__';

export const ORDERING_REQUIREMENT_UNITS_LABELS = {
    [OrderingRequirementUnit.Box]: 'Coli.s',
    [OrderingRequirementUnit.Eur]: 'euros (€)',
    [OrderingRequirementUnit.Quantity]: 'Unité.s',
    [OrderingRequirementUnit.G]: 'g',
    [OrderingRequirementUnit.Ml]: 'ml',
};

export const ORDER_MODE_LABELS = {
    [OrderMode.Email]: 'Par email',
    [OrderMode.Platform]: 'Espace de commande web/mobile',
};

// Société Odoo acheteuse : société du bon de commande, entrepôt de réception et TVA d'achat.
export const ODOO_COMPANY_LABELS = {
    [OdooCompany.Nseda]: 'NSEDA',
    [OdooCompany.Neocorner]: 'Neocorner (NCS)',
};
